module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/m53v23/tc-custom/9781626811508.jpg?1726871266043",
      "alt": "This image is the cover for the book Homecoming"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Homecoming\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From a national bestselling author and “one of the superstars of western romance” comes a tale of love and reconciliation in the aftermath of war ("), _c('i', [_vm._v("Affaire de Coeur")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" For most Texans, the Reconstruction might as well have been a second declaration of war. Matt Coltrane feels no different when he returns home to find his farm ravaged as part of a greedy land grab. Bitter and betrayed, he wants nothing to do with anyone . . . except the one girl he never forgot."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" After raiders killed her parents and destroyed their family home, Laine Ellis was left to raise her brother and sister in a cabin at the edge of the bayou. Stubborn and courageous, Laine doesn’t entertain any man’s attention—until Matt returns. She once loved him with a girl’s starry-eyed innocence. Now wants him with a woman’s passion."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Laine and Matt face old enemies and new challenges as they struggle to bring their dreams to life, putting aside their shared pain to fight against those who seek to keep them broken and defeated . . . in this rugged romantic novel from “a powerhouse writer whose emotional intensity keeps you enthralled” ("), _c('i', [_vm._v("RT Book Reviews")]), _vm._v(").\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Raine Cantrell\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Diversion Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0